export const Endpoint = 'https://api.avaluosingenio.com/';
// export const Endpoint = 'http://localhost:3001/';